module.exports = __webpack_public_path__ + "img/logo.1ef6f803.png";